<template>
  <main>
    <div class="container">
      <ExploreNav></ExploreNav>
      <div id="themes" class="row">
        <template v-for="(themes, index) in exploreData">
          <Theme :themeData="themes" :tagList="tagList" :searchDataExpanded="searchDataExpanded" :key="index"></Theme>
        </template>
      </div>
    </div>
    <Footer></Footer>
  </main>
</template>

<script>
// @ is an alias to /src
import ExploreNav from '@/components/ExploreNav.vue'
import Theme from '@/components/Theme.vue'
import DataManager from '@/assets/DataManager.js'
import SearchDataParser from '@/assets/SearchDataParser.js'
import Footer from '@/components/Footer.vue'

export default {
  data() {
    return {
      exploreData: [],
      tagList: [],
      searchDataExpanded: []
    }
  },
  components: {
    ExploreNav, Theme, Footer
  },
  created() {
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Temaer');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
    DataManager.getData([
        DataManager.menuList,
        DataManager.tagList,
        DataManager.searchData,
        DataManager.searchDataExpanded
      ], (response) => {

      this.exploreData = response[0].data;
      this.tagList = response[1].data;
      this.searchDataExpanded = SearchDataParser(response[2].data, response[3].data).searchDataExpanded;
    });
    document.getElementById('themes-tab').classList.add('active');
  },
}
</script>

<style lang="scss" scoped>

</style>
